import {
  MODULE_NAME,
  PERMISSION,
  PERMISSION_LEVEL,
} from '@shared/constants/moduleAndPermissions';
import { Permission, PermissionLevel } from '@shared/types';

type PermissionType = {
  name: Permission;
  level: PermissionLevel;
};

type Page = {
  name: string;
  pathname: string;
  requiredModules?: MODULE_NAME[];
  requiredPermissions?: PermissionType[];
  requiredAccountPermissions?: PermissionType[];
};

type Pages = {
  [key: string]: Page;
};

export const PAGES: Pages = {
  dashboard: {
    name: 'dashboard',
    pathname: '/dashboard',
    requiredModules: [MODULE_NAME.DASHBOARD],
    requiredPermissions: [
      { name: PERMISSION.DASHBOARD, level: PERMISSION_LEVEL.READ },
    ],
  },
  flp: {
    name: 'flp',
    pathname: '/flp',
    requiredModules: [MODULE_NAME.TASK_MANAGEMENT],
    requiredPermissions: [
      { name: PERMISSION.TASK_MANAGEMENT, level: PERMISSION_LEVEL.READ },
    ],
  },
  schedule: {
    name: 'schedule',
    pathname: '/schedule',
    requiredModules: [MODULE_NAME.SCHEDULE],
    requiredPermissions: [
      { name: PERMISSION.SCHEDULING, level: PERMISSION_LEVEL.READ },
    ],
  },
  time: {
    name: 'time',
    pathname: '/transfertopayroll',
    requiredModules: [MODULE_NAME.TIME],
    requiredPermissions: [
      { name: PERMISSION.TRANSFER_TO_PAYROLL, level: PERMISSION_LEVEL.READ },
    ],
  },
  people: {
    name: 'people',
    pathname: '/people',
    requiredModules: [MODULE_NAME.PEOPLE],
    requiredPermissions: [
      { name: PERMISSION.PEOPLE, level: PERMISSION_LEVEL.READ },
    ],
  },
  analytics: {
    name: 'analytics',
    pathname: '/reports',
    requiredModules: [MODULE_NAME.ANALYTICS],
    requiredPermissions: [
      { name: PERMISSION.ANALYTICS, level: PERMISSION_LEVEL.READ },
    ],
  },
  forecast: {
    name: 'forecast',
    pathname: '/forecast',
    requiredModules: [MODULE_NAME.FORECAST],
    requiredPermissions: [
      { name: PERMISSION.FORECAST_OVERVIEW, level: PERMISSION_LEVEL.READ },
    ],
  },
  news: {
    name: 'news',
    pathname: '/news',
    requiredPermissions: [
      { name: PERMISSION.NEWSFEED, level: PERMISSION_LEVEL.READ },
    ],
    requiredAccountPermissions: [
      { name: PERMISSION.ACCOUNT, level: PERMISSION_LEVEL.READ },
    ],
  },
  optimization: {
    name: 'optimization',
    pathname: '/optimization',
    requiredPermissions: [
      { name: PERMISSION.OPTIMIZATION_SETTINGS, level: PERMISSION_LEVEL.READ },
    ],
  },
  auditLogs: {
    name: 'auditLogs',
    pathname: '/audit-logs',
    requiredModules: [MODULE_NAME.SCHEDULE],
  },
  group: {
    name: 'group',
    pathname: '/group',
    requiredPermissions: [
      { name: PERMISSION.SETTINGS, level: PERMISSION_LEVEL.READ },
    ],
  },
  account: {
    name: 'account',
    pathname: '/account',
    requiredAccountPermissions: [
      { name: PERMISSION.ACCOUNT, level: PERMISSION_LEVEL.READ },
    ],
  },
};
